import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useAuth } from "../../../hooks";
import AgoraWrapper from "../Karaokecard/AgoraWrapper";
import Sing4YouPerformerStream from "./Sing4YouPerformerStream";

export function Sing4YouPerformerPage() {
  const { channel_name } = useParams();
  const navigate = useNavigate();
  const { userInfo } = useAuth();
  const [params] = useSearchParams();
  const performerName = params.get("performerName") || "Performer";

  const handleCallEnd = () => navigate(-1);

  if (!userInfo?.id) return <></>;

  return (
    <AgoraWrapper mode="live" role="host">
      <Sing4YouPerformerStream
        userId={userInfo.id.toString()}
        videoId={channel_name!}
        onCallEnd={handleCallEnd}
        performerName={performerName}
      />
    </AgoraWrapper>
  );
}

export default Sing4YouPerformerPage;
